import { SingleLineConfiguration } from "../models/line-configurations.model"
import { Choice, Component } from "../models/order/api-models/order-pd-response.model"

function isLineNewOrTouched(lineConfig: SingleLineConfiguration | undefined | null): boolean {
  const transactionType = lineConfig?.device?.transactionType;
  // Anything that is not an existing/upgrade transaction is a brand new line.
  if (transactionType !== 'existing' && transactionType !== 'upgrade') {
    return true;
  }
  // Existing/upgrade line only counts once the user has actually started changing it.
  return !!(lineConfig?.device?.upgradeProcessInitiated || lineConfig?.upgradeDevice?.preUpgradeProcessCompleted);
}


function findOffers(data: Component) {
  const offers = {
    wirelessDevices: [] as any[],
    wirelessPlanOffers: [] as Choice[],
    installmentPlanOffers: [] as Choice[],
    protectionPlanOffers: [] as Choice[],
    standardPromotions: [] as Choice[],
    shippingOptions: [] as Choice[],
    wirelessLineOptionChoices: [] as Choice[]
  }

  function processCustomization(customization: any) {
    if (!customization.Choices?.Choice) return

    const validChoices = customization.Choices.Choice.filter(
      (choice: any) => choice.Description !== null
    ).map(choice => {
      return {
        ...choice,
        CustomizationCode: customization.CustomizationCode,
        CustomizationName: customization.Name,
        CustomizationType: customization.CustomizationType,
        CustomizationDescription: customization.Description
      }
    })

    if (customization.SubGroupName === 'WirelessDevices') {
      offers.wirelessDevices.push(...validChoices)
    } else if (customization.SubGroupName === 'WirelessPlan') {
      offers.wirelessPlanOffers.push(...validChoices)
    } else if (customization.SubGroupName === 'WirelessPayPlan') {
      offers.installmentPlanOffers.push(...validChoices)
    } else if (customization.SubGroupName === 'WirelessInsurance') {
      offers.protectionPlanOffers.push(...validChoices)
    } else if (customization.SubGroupName === 'WirelessPromotion' && customization.Choices?.Choice?.length === 1) {
      offers.standardPromotions.push(...validChoices)
    } else if (customization.SubGroupName === 'Shipping') {
      offers.shippingOptions.push(...validChoices)
    }

    if (customization.SubGroupName === 'WirelessLineOptions') {
      offers.wirelessLineOptionChoices.push(...validChoices)
    }
  }

  function recurse(obj: any) {
    if (!obj) return

    if (obj.Customizations?.Customization) {
      obj.Customizations.Customization.forEach(processCustomization)
    }

    if (typeof obj === 'object') {
      Object.values(obj).forEach(value => {
        if (Array.isArray(value)) {
          value.forEach(recurse)
        } else if (typeof value === 'object') {
          recurse(value)
        }
      })
    }
  }

  recurse(data)

  return {
    wirelessPlanOffers: offers.wirelessPlanOffers,
    installmentPlanOffers: offers.installmentPlanOffers,
    protectionPlanOffers: offers.protectionPlanOffers,
    wirelessDevices: offers.wirelessDevices,
    standardPromotions: offers.standardPromotions,
    shippingOptions: offers.shippingOptions,
    wirelessLineOptionChoices: offers.wirelessLineOptionChoices
  }
}

export { findOffers, isLineNewOrTouched };
